/**
 * Updates the recently viewed products in localStorage.
 *
 * Todo acceso a `localStorage` va envuelto. No es defensa por si acaso: con el almacenamiento roto
 * —ventana privada, cuota llena, bloqueo del navegador— este modulo lanzaba QuotaExceededError SIN
 * CAPTURAR, dos `pageerror` por carga, con la traza en getProducts. El modulo de favoritos convive
 * con lo mismo y no lanza ninguno, porque envuelve sus accesos; este no lo hacia.
 *
 * Criterio: esto es una comodidad, no un dato del pedido. Si no se puede leer o escribir, se sigue
 * como si no hubiera historial — nunca se rompe la pagina por no poder recordar lo ya visto.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * El almacen, o null si no se puede usar. El propio acceso a `window.localStorage` lanza en
   * algunos navegadores con las cookies bloqueadas, asi que tambien va dentro del try.
   * @returns {Storage|null}
   */
  static #store() {
    try {
      return window.localStorage;
    } catch (e) {
      return null;
    }
  }

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    const store = this.#store();
    if (!store) return;
    try {
      store.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch (e) {
      // Cuota llena o escritura denegada: no se puede recordar, y no pasa nada.
    }
  }

  static clearProducts() {
    const store = this.#store();
    if (!store) return;
    try {
      store.removeItem(this.#STORAGE_KEY);
    } catch (e) {
      // Nada que limpiar si no hay almacen.
    }
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    const store = this.#store();
    if (!store) return [];
    let crudo = null;
    try {
      crudo = store.getItem(this.#STORAGE_KEY);
    } catch (e) {
      return [];
    }
    if (!crudo) return [];
    try {
      const lista = JSON.parse(crudo);
      // Un valor corrompido por otra pestaña o version no debe tumbar la pagina.
      return Array.isArray(lista) ? lista : [];
    } catch (e) {
      return [];
    }
  }
}
